import(/* webpackMode: "eager" */ "/app/app/[locale]/(public)/error.tsx");
